import React, { useState } from 'react';
import PlayerFilters from './playerFilters';
import PlayersTable from './playersTable';

export const initialFilters = {
    positions: '',
    leagues: '',
    availability: 'Available',
    search: '',
}

function handleSetFilter(oldFilters, selectedOption, filterName){
    return {...oldFilters, [filterName]: selectedOption};
}

const Filters = React.memo(PlayerFilters);

function PlayersContainer({players, selectedPlayers, handleAddPlayer, isMyTurn}){
    const [ filtersState, setFilter ] = useState(initialFilters);
    return (
    <>
        <Filters
            filtersState={filtersState}
            setFilter={(opt, filterName) => setFilter(handleSetFilter(filtersState, opt, filterName))}
        />
        <PlayersTable
            filters={filtersState}
            players={players}
            selectedPlayers={selectedPlayers}
            handleAddPlayer={handleAddPlayer}
            isMyTurn={isMyTurn}
            actionButtonLabel="Draft"
        />
    </>
    );
}

export default PlayersContainer;